import { findBestMatch, compareTwoStrings } from 'string-similarity';
import {CleanPatient} from "../api/medical-operations/models/clean-patient";
import { BasicInfoPatient } from "../api/medical-operations/models/basic-info-patient";

type Patients = BasicInfoPatient[] | CleanPatient[];
export function fuzzySearch(patients: Patients, searchQuery: string): Patients {
    const patientNames = patients.map((patient) => `${patient.FirstName} ${patient.FamilyName}`);
    const bestMatch = findBestMatch(searchQuery, patientNames);

    const sortedPatients = bestMatch.ratings
        .map((rating, index) => ({ rating, patient: patients[index] }))
        .sort((a, b) => b.rating.rating - a.rating.rating)
        .map((item) => item.patient);

    return sortedPatients;
}

export function similarityCompare(searchQuery: string, firstName:string, familyName:string, primaryPhone: string): boolean {
    if(
        compareTwoStrings(searchQuery, firstName)>0.5
        || compareTwoStrings(searchQuery, familyName)>0.5
        || compareTwoStrings(searchQuery, primaryPhone.slice(1))>0.45
    )
    {
        return true;
    }
    else{
        return false;
    }
}